import { render, staticRenderFns } from "./list_schools.vue?vue&type=template&id=2b8c0de0&scoped=true&"
import script from "./list_schools.vue?vue&type=script&lang=js&"
export * from "./list_schools.vue?vue&type=script&lang=js&"
import style0 from "./list_schools.vue?vue&type=style&index=0&id=2b8c0de0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8c0de0",
  null
  
)

export default component.exports